import { motion, useReducedMotion } from "framer-motion";
import "./ScanToOrderScene.css";
import demoMenuMobile from "../../assets/marketing/demo-menu-mobile.webp";
import tesztEtteremQr from "../../assets/qr/teszt-etterem-qr.webp";

// Original illustrated composition (no stock photography) telling the
// scan -> browse -> order story: a real, scannable QR code for the live
// Teszt Étterem demo and a real screenshot of the demo menu, arranged as
// a small tabletop scene.
function ScanToOrderScene() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className="scan-scene"
      initial={prefersReducedMotion ? false : { opacity: 0, scale: 0.94 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="scan-scene-surface" aria-hidden="true" />

      <span className="scan-table-chip">3. asztal</span>

      <div className="scan-qr-card">
        <span className="scan-qr-pulse" aria-hidden="true" />
        <img
          src={tesztEtteremQr}
          alt="Valódi, beolvasható QR kód a Teszt Étterem élő Tablify menüjéhez"
          className="scan-qr-glyph"
          width="64"
          height="64"
          loading="lazy"
        />
        <span className="scan-qr-label">Olvasd be &amp; rendelj</span>
      </div>

      <svg className="scan-path" viewBox="0 0 300 220" fill="none" aria-hidden="true">
        <path
          d="M70 165 C 110 120, 150 90, 205 65"
          stroke="var(--color-accent-active)"
          strokeWidth="2.5"
          strokeDasharray="1 10"
          strokeLinecap="round"
        />
      </svg>

      <div className="scan-phone">
        <div className="scan-phone-notch" aria-hidden="true" />
        <img
          src={demoMenuMobile}
          alt="Valódi Tablify digitális étlap, ahogy a vendég a QR-kód beolvasása után látja"
          loading="lazy"
        />
      </div>

      <motion.span
        className="scan-order-chip"
        initial={prefersReducedMotion ? false : { opacity: 0, y: 8, scale: 0.9 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.4, delay: 0.5 }}
      >
        ✓ Rendelés elküldve
      </motion.span>
    </motion.div>
  );
}

export default ScanToOrderScene;
